import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function TomosAndBonos() {
  const [activeTramo, setActiveTramo] = useState(0);
  const tramos = ['Inicial', '1° y 2°', '3° y 4°', '5° y 6°'];
  const tomos = [{
    num: 1,
    icon: '📘',
    name: 'Matemáticas'
  }, {
    num: 2,
    icon: '⚗️',
    name: 'Física y Química'
  }, {
    num: 3,
    icon: '🌿',
    name: 'Ciencias Biológicas'
  }, {
    num: 4,
    icon: '🌍',
    name: 'Ciencias de la Tierra'
  }, {
    num: 5,
    icon: '📖',
    name: 'Lengua Española'
  }, {
    num: 6,
    icon: '🏛️',
    name: 'Historia'
  }, {
    num: 7,
    icon: '🗺️',
    name: 'Geografía'
  }, {
    num: 8,
    icon: '⚖️',
    name: 'Ciudadanía'
  }];
  const bonos = [{
    tramo: 'TRAMO 1 · Educación Inicial',
    icon: '📘',
    items: ['Juego simbólico y las 8 áreas del EBI', 'Mensajes para familias listos', 'Actividades para el día difícil']
  }, {
    tramo: 'TRAMO 2 · 1° y 2° año',
    icon: '📗',
    items: ['Conciencia fonológica con rúbricas listas', 'Cuando el grupo no puede con la lectura', '1° y 2° juntos · cómo organizarlo']
  }, {
    tramo: 'TRAMO 3 · 3° y 4° año',
    icon: '📙',
    items: ['Historia y Ciudadanía integradas', 'Evaluaciones express para las 8 áreas', 'El sistema para el domingo libre']
  }, {
    tramo: 'TRAMO 4 · 5° y 6° año',
    icon: '📓',
    items: ['Bioética y genética en 6° año', 'Proyecto ciudadano listo para el egreso', 'Feria de Ciencias sin estrés']
  }];
  return <>
      {/* SECCIÓN 4: LOS TOMOS */}
      <section className="py-16 px-4 bg-brand-lightBlue" data-id="element-183">
        <div className="max-w-5xl mx-auto" data-id="element-184">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-brand-deep text-center mb-8" data-id="element-185">
            ¿Qué incluye cada tramo?
          </h2>

          <div className="flex flex-wrap justify-center gap-2 mb-10" data-id="element-186">
            {tramos.map((tramo, i) => <button key={i} onClick={() => setActiveTramo(i)} className={`px-6 py-2 rounded-full font-bold transition-colors ${activeTramo === i ? 'bg-brand-blue text-white shadow-md' : 'bg-white text-brand-text border border-brand-sky hover:bg-blue-50'}`} data-id="element-187">
                {tramo}
              </button>)}
          </div>

          <AnimatePresence mode="wait" data-id="element-188">
            <motion.div key={activeTramo} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.2
          }} data-id="element-189">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12" data-id="element-190">
                {tomos.map((tomo, i) => <div key={i} className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 text-center flex flex-col items-center justify-center aspect-square" data-id="element-191">
                    <div className="text-4xl mb-2" data-id="element-192">{tomo.icon}</div>
                    <div className="text-xs text-brand-gray font-bold uppercase tracking-wider mb-1" data-id="element-193">
                      Tomo {tomo.num}
                    </div>
                    <div className="font-bold text-brand-deep leading-tight" data-id="element-194">
                      {tomo.name}
                    </div>
                  </div>)}
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-brand-sky max-w-3xl mx-auto" data-id="element-195">
            <h3 className="text-xl font-display font-bold text-brand-deep mb-6 text-center" data-id="element-196">
              CADA TOMO INCLUYE:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-197">
              {['Planificación anual lista para el director/a', '7 bloques con todas las fichas del año', 'Actividades listas para el aula', 'Evaluaciones + rúbricas + autoevaluación', 'Registro grupal y seguimiento individual', 'Conexión con la realidad uruguaya', 'Alineado al Programa EBI · ANEP 2026'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-198">
                  <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-199" />
                  <span className="text-brand-text font-medium" data-id="element-200">{item}</span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 5: BONOS */}
      <section className="py-16 px-4 bg-white" data-id="element-201">
        <div className="max-w-5xl mx-auto" data-id="element-202">
          <div className="text-center mb-12" data-id="element-203">
            <h2 className="text-3xl md:text-5xl font-display font-bold text-brand-deep mb-4" data-id="element-204">
              + 6 Bonos Estratégicos por tramo
            </h2>
            <p className="text-xl text-brand-text font-medium" data-id="element-205">
              Incluidos en todas las opciones · sin costo extra
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-206">
            {bonos.map((bono, i) => <div key={i} className="bg-brand-lightBlue rounded-2xl p-6 border border-brand-sky relative overflow-hidden" data-id="element-207">
                <div className="absolute top-0 right-0 bg-brand-orange text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-208">
                  6 bonos incluidos
                </div>
                <h3 className="text-xl font-display font-bold text-brand-deep mb-4 flex items-center gap-2" data-id="element-209">
                  <span className="text-2xl" data-id="element-210">{bono.icon}</span> {bono.tramo}
                </h3>
                <ul className="space-y-3 mb-6" data-id="element-211">
                  {bono.items.map((item, j) => <li key={j} className="flex items-start gap-2 text-brand-text font-medium" data-id="element-212">
                      <span className="text-brand-orange" data-id="element-213">🎁</span> {item}
                    </li>)}
                </ul>
                <div className="flex items-center gap-3 pt-4 border-t border-brand-sky" data-id="element-214">
                  <span className="text-brand-gray line-through font-bold" data-id="element-215">
                    $990
                  </span>
                  <span className="text-brand-green font-display font-bold text-xl" data-id="element-216">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>

          <div className="bg-gradient-to-r from-[#FB8C00] to-[#EF6C00] text-white text-center p-6 rounded-2xl shadow-[0_8px_24px_rgba(245,124,0,0.3)] max-w-2xl mx-auto" data-id="element-217">
            <p className="text-xl md:text-2xl font-display font-bold mb-2" data-id="element-218">
              🎁 $990 en bonos por tramo — GRATIS
            </p>
            <p className="text-orange-100 font-medium" data-id="element-219">
              Incluidos en todas las opciones. Siempre.
            </p>
          </div>
        </div>
      </section>
    </>;
}